import { render, staticRenderFns } from "./DangerReportDetail.vue?vue&type=template&id=68655874&"
import script from "./DangerReportDetail.vue?vue&type=script&lang=js&"
export * from "./DangerReportDetail.vue?vue&type=script&lang=js&"
import style0 from "./DangerReportDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68655874')) {
      api.createRecord('68655874', component.options)
    } else {
      api.reload('68655874', component.options)
    }
    module.hot.accept("./DangerReportDetail.vue?vue&type=template&id=68655874&", function () {
      api.rerender('68655874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/DangerReportDetail.vue"
export default component.exports